import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ChecklisAreatService } from "../../master-services/check-list/checklistArea.service";
import swal from "sweetalert2";
import { error } from "console";

@Component({
  selector: "checklist-group-component",
  templateUrl: "./checklist-group.component.html",
  styleUrls: ["./checklist-group.component.scss"],
})
export class ChecklistGroupComponent implements OnInit {
  pdfList: any;
  checkListId: any;
  constructor(
    private router: Router,
    private rutaActiva: ActivatedRoute,
    private ChecklisAreatService: ChecklisAreatService
  ) {
    this.checkListId = this.rutaActiva.snapshot.params.id;
    this.index(this.checkListId);
  }
  ngOnInit() {}

  index(checkListId) {
      this.ChecklisAreatService.getPdf(checkListId)
      .then(data => {
        const reps :any = data
        console.log(reps)
        this.pdfList = reps.data;
      })
  }

  managearea(id: any) {
    this.router.navigateByUrl("erp/manageArea/" + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/master/checklist-group/checklist-group.component.ts